import router from '@/router'

// 读取缓存，回到当前收银台url
export function backOriCashierPage() {
  const val = sessionStorage.getItem("CashierParam") || '';
  if (val) {
    router.replace({
      path: `/payMethod`,
      query: { 
        params: val 
      }
    });
  }
}

// 跳转到下级页面（A->B, B->C）
export function goToNext(routeName, params = {}) {
  // 使用push添加新记录
  router.push({
    name: routeName,
    params,
    query: { from: router.currentRoute.name }
  })
}

// 返回上级页面（C->B, B->A）
export function goBack() {
  const currentRoute = router.currentRoute
  const from = currentRoute.query.from
  
  if (from) {
    // 如果有来源记录，直接返回来源页
    router.push({ name: from })
  } else {
    // 否则根据层级判断
    const level = currentRoute.meta.level
    if (level > 1) {
      // 找到上一级路由
      const routes = router.options.routes
      const parentRoute = routes.find(r => r.meta.level === level - 1)
      if (parentRoute) {
        router.push({ name: parentRoute.name })
      }
    }
  }
}